import { Box } from '@mui/material'
import { FONT_SANS, TOKENS } from './SchedulerDesign'

/**
 * Week picker for the per-week input tables.
 *
 * The scheduler plans an 8-week horizon, so the range is always 1–8 — the same
 * assumption `SchedulerInput.page`'s top strip makes. Extracted from
 * `ScheduleWorkstationDowntime.view` when the Resource Capacity Profile tab
 * became the second per-week table: two copies of this control would drift,
 * and a planner moving between the two tabs should not see the week change
 * shape.
 */
export const WeekSelector = ({
  value,
  onChange,
}: {
  value: number
  onChange: (w: number) => void
}) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1.5 }}>
    {[1, 2, 3, 4, 5, 6, 7, 8].map((w) => {
      const on = w === value
      return (
        <Box
          component="button"
          key={w}
          onClick={() => onChange(w)}
          sx={{
            width: 26,
            height: 26,
            border: '1px solid',
            borderColor: on ? TOKENS.brandTeal : TOKENS.line300,
            background: on ? TOKENS.brandTeal : '#fff',
            color: on ? '#fff' : TOKENS.ink500,
            borderRadius: '2px',
            fontSize: 11,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: FONT_SANS,
          }}
        >
          {w}
        </Box>
      )
    })}
  </Box>
)
